import { useState, type ReactNode } from 'react';

interface Props {
  title: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  headerRight?: ReactNode;
}

export function Collapsible({ title, children, defaultOpen = true, headerRight }: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50 transition-colors"
        style={{ borderBottom: open ? '1px solid #e5e7eb' : 'none' }}
      >
        <span
          className="text-sm font-semibold text-gray-800"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          {title}
        </span>
        <span className="flex items-center gap-2">
          {headerRight}
          <span
            className="text-gray-400 text-xs"
            style={{
              display: 'inline-block',
              transform: open ? 'rotate(180deg)' : 'none',
              transition: 'transform 150ms',
            }}
          >
            ▼
          </span>
        </span>
      </button>
      {open && <div>{children}</div>}
    </div>
  );
}
